var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStakingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11.4238C20.9705 11.4238 25 10.2094 25 8.71143V13.7472C25 15.164 20.9705 16.3553 16 16.3553C11.0294 16.3553 7 15.164 7 13.7472V12.6539C7.08217 12.7276 7.1697 12.795 7.25872 12.8563C7.66958 13.1392 8.23477 13.3798 8.89549 13.5822C10.2237 13.989 12.0547 14.276 14.1235 14.3888C14.3992 14.4038 14.6349 14.1924 14.6499 13.9167C14.665 13.641 14.4536 13.4053 14.1779 13.3902C12.1576 13.2802 10.4132 13.0012 9.18837 12.6261C8.57255 12.4374 8.11678 12.233 7.82581 12.0327C7.5179 11.8207 7.5 11.6906 7.5 11.6703C7.5 11.3942 7.27614 11.1703 7 11.1703V8.71143C7 10.2094 11.0294 11.4238 16 11.4238ZM16.3767 14.8758C16.3767 15.152 16.1529 15.3758 15.8767 15.3758C15.6006 15.3758 15.3767 15.152 15.3767 14.8758V13.3964C15.3767 13.1202 15.6006 12.8964 15.8767 12.8964C16.1529 12.8964 16.3767 13.1202 16.3767 13.3964V14.8758Z",
    fill: "url(#paint0_linear_79_609)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 13.8901C25 15.3881 20.3151 16.3559 16 16.3559C11.6849 16.3559 7 15.3881 7 13.8901V15.8557C7.27614 15.8557 7.5 16.0795 7.5 16.3557C7.5 16.4807 7.57074 16.6723 7.8642 16.9193C8.15457 17.1636 8.60676 17.4113 9.21723 17.6398C10.4336 18.0952 12.1695 18.4349 14.1839 18.5691C14.4594 18.5875 14.6679 18.8257 14.6496 19.1012C14.6312 19.3768 14.393 19.5853 14.1175 19.5669C12.0427 19.4287 10.2033 19.0768 8.86662 18.5764C8.20056 18.327 7.63179 18.0307 7.22033 17.6844C7.14293 17.6193 7.069 17.5505 7 17.4781V19.1725C7 20.5893 11.0294 21.7805 16 21.7805C20.9705 21.7805 25 20.5893 25 19.1725V13.8901ZM15.8767 20.0612C16.1529 20.0612 16.3767 19.8373 16.3767 19.5612V18.0817C16.3767 17.8056 16.1529 17.5817 15.8767 17.5817C15.6006 17.5817 15.3767 17.8056 15.3767 18.0817V19.5612C15.3767 19.8373 15.6006 20.0612 15.8767 20.0612Z",
    fill: "url(#paint1_linear_79_609)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 21.7807C20.9705 21.7807 25 20.5663 25 19.0684V24.1041C25 25.5209 20.9705 26.7122 16 26.7122C11.0294 26.7122 7 25.5209 7 24.1041V22.8331C7.07503 22.9062 7.1553 22.9745 7.23846 23.0381C7.65004 23.353 8.21738 23.6215 8.88083 23.8473C10.2135 24.3008 12.0487 24.6202 14.1205 24.7457C14.3961 24.7624 14.6331 24.5524 14.6498 24.2768C14.6665 24.0012 14.4565 23.7642 14.1809 23.7475C12.1635 23.6253 10.4235 23.316 9.20303 22.9006C8.58994 22.6919 8.13632 22.4659 7.84607 22.2439C7.54745 22.0154 7.5 21.8552 7.5 21.7808C7.5 21.5047 7.27614 21.2808 7 21.2808V19.0684C7 20.5663 11.0294 21.7807 16 21.7807ZM16.3767 24.9863C16.3767 25.2624 16.1529 25.4863 15.8767 25.4863C15.6006 25.4863 15.3767 25.2624 15.3767 24.9863V23.5068C15.3767 23.2307 15.6006 23.0068 15.8767 23.0068C16.1529 23.0068 16.3767 23.2307 16.3767 23.5068V24.9863Z",
    fill: "url(#paint2_linear_79_609)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13.8902C25 15.252 20.9705 16.356 16 16.356C11.0294 16.356 7 15.252 7 13.8902",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19.0684C7 20.5664 11.0294 21.7808 16 21.7808C18.2998 21.7808 20.3981 21.5208 21.9891 21.0931C22.5817 20.9113 23.989 20.3506 24.8767 19.5616",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8.7124V19.4384V24.4932C24.211 25.1836 23.1918 25.6586 22.7808 25.8097C21.131 26.3596 18.7048 26.7124 16 26.7124C11.0294 26.7124 7 25.5211 7 24.1043V8.7124",
    stroke: "#302F3A",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.9248C18.4508 10.9248 20.6503 10.6273 22.2208 10.1579C23.0092 9.92223 23.6109 9.65153 24.0042 9.37358C24.4108 9.08624 24.5 8.86302 24.5 8.73489C24.5 8.60537 24.4092 8.37915 24.0017 8.08742C23.6078 7.80547 23.0058 7.52954 22.2177 7.28857C20.6478 6.80854 18.4492 6.50015 16 6.50015C13.5508 6.50015 11.3522 6.80854 9.78223 7.28857C8.99415 7.52954 8.39217 7.80547 7.99831 8.08742C7.59078 8.37915 7.5 8.60537 7.5 8.73489C7.5 8.86302 7.58917 9.08624 7.99581 9.37359C8.38914 9.65153 8.99077 9.92223 9.77922 10.1579C11.3497 10.6273 13.5492 10.9248 16 10.9248Z",
    stroke: "url(#paint3_linear_79_609)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_609",
    x1: 16,
    y1: 9.09362,
    x2: 16,
    y2: 16.3553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_609",
    x1: 7,
    y1: 13.8901,
    x2: 17.0008,
    y2: 27.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_609",
    x1: 16,
    y1: 19.4506,
    x2: 16,
    y2: 26.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_609",
    x1: 16,
    y1: 11.4248,
    x2: 16,
    y2: 6.00015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingIcon);
export default __webpack_public_path__ + "static/media/stakingIcon.d8c712053e2772a80722a70da02701d7.svg";
export { ForwardRef as ReactComponent };